import { render, staticRenderFns } from "./_Empty.vue?vue&type=template&id=a60beab2&scoped=true"
import script from "./_Empty.vue?vue&type=script&lang=js"
export * from "./_Empty.vue?vue&type=script&lang=js"
import style0 from "./_Empty.vue?vue&type=style&index=0&id=a60beab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60beab2",
  null
  
)

export default component.exports